export default __webpack_public_path__ + "static/media/triple-point-asset-30.af7fd950.png";